<template>
    <div class="province-analysis-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <!-- 筛选区 -->
            <div class="search-box">
                <el-select v-model="filterForm.cc" multiple placeholder="全部层次" style="width: 200px;" clearable>
                    <el-option v-for="item in ccOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="filterForm.pc" multiple placeholder="全部批次" style="width: 200px;" clearable>
                    <el-option v-for="item in pcOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                <el-button @click="resetFilter">重置</el-button>
            </div>

            <!-- 全国录取情况分析 & 地图 -->
            <div class="section-block">
                <h3 class="section-title">全国录取情况分析</h3>
                <p v-html="analysisText"></p>
                <div class="chart-wrapper">
                    <el-button class="download-btn" size="mini" icon="el-icon-download" @click="downloadMap">下载图片</el-button>
                    <v-chart ref="mapChart" :option="mapOption" style="height: 400px; width: 60%; margin: auto;" autoresize></v-chart>
                </div>
            </div>

            <!-- 直方图 -->
            <div class="section-block">
                <h3 class="section-title">各省份录取人数直方图</h3>
                <div class="chart-wrapper">
                    <div class="chart-controls">
                        <el-checkbox v-model="hideHomeProvince" @change="generateBarChart">不显示本省</el-checkbox>
                    </div>
                    <div class="chart-controls-right">
                        <el-button size="mini" icon="el-icon-download" @click="downloadBar">下载图片</el-button>
                    </div>
                    <v-chart ref="barChart" :option="barOption" style="height: 350px;" autoresize></v-chart>
                </div>
            </div>

            <!-- 详情表格 -->
            <div class="section-block">
                <div class="section-header">
                    <h3 class="section-title">录取详情</h3>
                    <el-button type="success" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
                </div>
                <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="Province" label="省份" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="TotalCount" label="录取数" min-width="100" align="center"></el-table-column>

                            <!-- 性别 -->
                            <el-table-column label="性别" align="center">
                                <el-table-column prop="MaleCount" label="男" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.MaleCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="FemaleCount" label="女" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.FemaleCount || '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>

                            <!-- 考生类别 -->
                            <el-table-column label="考生类别" align="center">
                                <el-table-column prop="CityFreshCount" label="城市应届" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.CityFreshCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="CityFormerCount" label="城市往届" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.CityFormerCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="RuralFreshCount" label="农村应届" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.RuralFreshCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="RuralFormerCount" label="农村往届" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.RuralFormerCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="FreshCount" label="应届" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.FreshCount || '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="FormerCount" label="往届" min-width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.FormerCount || '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>

                            <!-- 分数情况 -->
                            <el-table-column label="分数情况" align="center">
                                <el-table-column prop="MaxScore" label="最高分" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.MaxScore ? scope.row.MaxScore.toFixed(1) : '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="MinScore" label="最低分" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.MinScore ? scope.row.MinScore.toFixed(1) : '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="AvgScore" label="平均分" min-width="90" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.AvgScore ? scope.row.AvgScore.toFixed(1) : '-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import VChart from 'vue-echarts';
    import * as echarts from 'echarts';
    import chinaJson from 'china-geojson/src/geojson/china.json';

    echarts.registerMap('china', chinaJson);

    // 引入所需组件
    import 'echarts/lib/chart/bar';
    import 'echarts/lib/chart/map';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/visualMap';

    export default {
        name: 'ProvinceAnalysis',
        components: {
            VChart
        },
        inject: ['Loading', 'LoadingCompleted'],
        data() {
            return {
                Status: {
                    LoadingCompleted: false
                },
                loading: false,
                filterForm: {
                    cc: [],
                    pc: []
                },
                ccOptions: [],
                pcOptions: [],
                tableData: [],
                analysisText: '',
                schoolName: '',
                year: 0,
                totalCount: 0,
                homeProvince: '湖北省',
                hideHomeProvince: false,
                mapOption: {},
                barOption: {},
                // 省份名称映射（数据库名称 -> 地图名称）
                provinceMap: {
                    '北京市': '北京',
                    '天津市': '天津',
                    '河北省': '河北',
                    '山西省': '山西',
                    '内蒙古自治区': '内蒙古',
                    '辽宁省': '辽宁',
                    '吉林省': '吉林',
                    '黑龙江省': '黑龙江',
                    '上海市': '上海',
                    '江苏省': '江苏',
                    '浙江省': '浙江',
                    '安徽省': '安徽',
                    '福建省': '福建',
                    '江西省': '江西',
                    '山东省': '山东',
                    '河南省': '河南',
                    '湖北省': '湖北',
                    '湖南省': '湖南',
                    '广东省': '广东',
                    '广西壮族自治区': '广西',
                    '海南省': '海南',
                    '重庆市': '重庆',
                    '四川省': '四川',
                    '贵州省': '贵州',
                    '云南省': '云南',
                    '西藏自治区': '西藏',
                    '陕西省': '陕西',
                    '甘肃省': '甘肃',
                    '青海省': '青海',
                    '宁夏回族自治区': '宁夏',
                    '新疆维吾尔自治区': '新疆',
                    '台湾省': '台湾',
                    '香港特别行政区': '香港',
                    '澳门特别行政区': '澳门'
                }
            };
        },
        methods: {
            loadFilters() {
                const that = this;
                const api_name = '/Analysis/GetProvinceFilters';
                const url = TYBM_Env.GetApiUrl(api_name);

                TYBM_Tools.AxiosGetEx(that, api_name, url, { loading: false })
                    .then(result => {
                        that.ccOptions = result.data.CcOptions;
                        that.pcOptions = result.data.PcOptions;
                    });
            },
            loadData() {
                const that = this;
                that.loading = true;

                const api_name = '/Analysis/GetProvinceData';
                let url = TYBM_Env.GetApiUrl(api_name);

                // 添加筛选参数
                const params = [];
                if (that.filterForm.cc && that.filterForm.cc.length > 0) {
                    params.push('CC=' + encodeURIComponent(that.filterForm.cc.join(',')));
                }
                if (that.filterForm.pc && that.filterForm.pc.length > 0) {
                    params.push('PC=' + encodeURIComponent(that.filterForm.pc.join(',')));
                }
                if (params.length > 0) {
                    url += '?' + params.join('&');
                }

                TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                    .then(result => {
                        that.tableData = result.data.StatList;
                        that.totalCount = result.data.TotalCount;
                        that.schoolName = result.data.SchoolName;
                        that.year = result.data.Year;
                        that.homeProvince = result.data.HomeProvince || '湖北省';

                        // 如果是首次加载，获取筛选选项
                        if (that.ccOptions.length === 0) {
                            that.loadFilters();
                        }

                        // 生成分析文字
                        that.generateAnalysisText();

                        // 生成图表
                        that.generateMapChart();
                        that.generateBarChart();

                        that.Status.LoadingCompleted = true;
                    })
                    .catch(() => {
                        that.$message.error('加载数据失败');
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            },
            resetFilter() {
                this.filterForm.cc = [];
                this.filterForm.pc = [];
                this.loadData();
            },
            generateAnalysisText() {
                const that = this;
                if (!that.tableData || that.tableData.length === 0) {
                    that.analysisText = '';
                    return;
                }

                // 找出本省
                const homeProvince = that.tableData.find(item => item.Province === that.homeProvince);
                const homeProvinceCount = homeProvince ? homeProvince.TotalCount : 0;
                const homeProvinceName = homeProvince ? homeProvince.Province : that.homeProvince;
                const homeProvinceRatio = that.totalCount > 0 ? (homeProvinceCount / that.totalCount * 100).toFixed(2) : 0;

                // 其他省份
                const otherProvinces = that.tableData.filter(item => item !== homeProvince);
                const otherProvincesText = otherProvinces.map(item => `${item.Province}${item.TotalCount}人`).join('、');

                that.analysisText = `${that.schoolName}${that.year}年共录取${that.totalCount}人，${homeProvinceName}录取${homeProvinceCount}人，占全国录取的${homeProvinceRatio}%；其他省份招生人数为${otherProvincesText}。`;
            },
            generateMapChart() {
                const that = this;

                // 准备地图数据，使用省份映射
                const mapData = that.tableData.map(item => ({
                    name: that.provinceMap[item.Province] || item.Province,
                    value: item.TotalCount
                }));

                that.mapOption = {
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            if (params.data) {
                                return params.name + '<br/>录取人数: ' + params.data.value + '人';
                            }
                            return params.name + '<br/>录取人数: 0人';
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max(...mapData.map(d => d.value)),
                        text: ['高', '低'],
                        realtime: false,
                        calculable: true,
                        inRange: {
                            color: ['#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695']
                        },
                        pieces: [
                            { min: 500, label: '500人以上', color: '#313695' },
                            { min: 200, max: 499, label: '200-500人', color: '#4575b4' },
                            { min: 100, max: 199, label: '100-199人', color: '#74add1' },
                            { min: 50, max: 99, label: '50-99人', color: '#abd9e9' },
                            { min: 20, max: 49, label: '20-49人', color: '#d1e5f0' },
                            { min: 10, max: 19, label: '10-19人', color: '#e0f3f8' },
                            { min: 1, max: 9, label: '1-9人', color: '#f7fbff' }
                        ]
                    },
                    series: [
                        {
                            name: '录取人数',
                            type: 'map',
                            map: 'china',
                            roam: true,
                            label: {
                                show: false
                            },
                            emphasis: {
                                label: {
                                    show: true
                                }
                            },
                            data: mapData
                        }
                    ]
                };
            },
            generateBarChart() {
                const that = this;

                // 根据"不显示本省"选项过滤数据
                let filteredData = that.tableData;
                if (that.hideHomeProvince) {
                    filteredData = that.tableData.filter(item => item.Province !== that.homeProvince);
                }

                const provinces = filteredData.map(item => item.Province);
                const counts = filteredData.map(item => item.TotalCount);

                that.barOption = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '15%',
                        top: '5%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: provinces,
                        axisLabel: {
                            interval: 0,
                            rotate: 45,
                            fontSize: 12
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: counts,
                            barWidth: 40,  // 固定柱宽
                            itemStyle: {
                                color: '#409EFF'
                            },
                            label: {
                                show: true,
                                position: 'top',
                                fontSize: 10
                            }
                        }
                    ]
                };
            },
            downloadMap() {
                const chart = this.$refs.mapChart;
                if (chart) {
                    const url = chart.getDataURL({
                        type: 'png',
                        pixelRatio: 2,
                        backgroundColor: '#fff'
                    });
                    const link = document.createElement('a');
                    link.download = `各省份录取分布地图_${this.year}.png`;
                    link.href = url;
                    link.click();
                }
            },
            downloadBar() {
                const chart = this.$refs.barChart;
                if (chart) {
                    const url = chart.getDataURL({
                        type: 'png',
                        pixelRatio: 2,
                        backgroundColor: '#fff'
                    });
                    const link = document.createElement('a');
                    link.download = `各省份录取人数直方图_${this.year}.png`;
                    link.href = url;
                    link.click();
                }
            },
            handleExport() {
                const that = this;
                if (that.tableData.length === 0) {
                    that.$message.warning('没有数据可导出');
                    return;
                }

                let csvContent = "\uFEFF"; // BOM for Excel UTF-8

                // 表头
                const headers = ["序号", "省份", "录取数", "男", "女", "城市应届", "城市往届", "农村应届", "农村往届", "应届", "往届", "最高分", "最低分", "平均分"];
                csvContent += headers.join(",") + "\n";

                // 数据行
                that.tableData.forEach((row, index) => {
                    const rowData = [
                        index + 1,
                        row.Province,
                        row.TotalCount,
                        row.MaleCount || '-',
                        row.FemaleCount || '-',
                        row.CityFreshCount || '-',
                        row.CityFormerCount || '-',
                        row.RuralFreshCount || '-',
                        row.RuralFormerCount || '-',
                        row.FreshCount || '-',
                        row.FormerCount || '-',
                        row.MaxScore ? row.MaxScore.toFixed(1) : '-',
                        row.MinScore ? row.MinScore.toFixed(1) : '-',
                        row.AvgScore ? row.AvgScore.toFixed(1) : '-'
                    ];
                    csvContent += rowData.join(",") + "\n";
                });

                // 下载
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `省份录取详情_${that.year}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        created() {
            this.loadData();
        },
        mounted() {
            // 监听年份变化
            this.$root.$on('global-year-change', this.loadData);
        },
        beforeDestroy() {
            this.$root.$off('global-year-change', this.loadData);
        }
    };
</script>

<style scoped>
.province-analysis-container {
    width: 100%;
}

/* 搜索框样式 - 参照ListSanBiao.vue */
.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    align-items: center;
}

/* 分块样式 */

    .section-block {
        margin-bottom: 0px;
        background: white;
        border-radius: 8px;
        padding: 5px;
    }

    .section-title {
        margin: 0 0 12px 0;
        color: #303133;
        font-size: 16px;
        font-weight: 600;
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
    }

    .chart-wrapper {
        position: relative;
        margin-top: 40px;
    }

    .chart-controls {
        position: absolute;
        left: 10px;
        top: -30px;
        z-index: 10;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .chart-controls-right {
        position: absolute;
        right: 10px;
        top: -30px;
        z-index: 10;
        display: flex;
        gap: 10px;
        align-items: center;
    }


.download-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}
</style>
